import { Component, OnInit, Input, OnDestroy, Optional, forwardRef } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { HeaderCalendarComponent } from '../../header-calendar/header-calendar.component';
import { LoadDrupalLangService } from '../../../../../../common-page-components/services/load-drupal-lang.service';
import { RouterFilterReference } from '../../../common/filters-router/filters-router.component';
import { FiltersTypeEnum } from "world-archery-lib";
@Component({
  selector: "lib-date-filter",
  templateUrl: "./date-filter.component.html",
  styleUrls: ["./date-filter.component.scss"],
  providers:[
    {provide: RouterFilterReference, useExisting: forwardRef(() => DateFilterComponent)}
  ]
})
export class DateFilterComponent extends RouterFilterReference implements OnInit, OnDestroy {
  public customHeader = HeaderCalendarComponent;
  private subs: Array<Subscription> = [];
  public date: Date;

  /**
   *
   * Type of format to show date. See Angular DatePipe for options
   * @type {string}
   * @memberof DateFilterComponent
   */
  @Input() format: string = "dd/ MMMM /yyyy";
  @Input() id: string;
  /**
   *
   * Place holder of input
   * @type {string}
   * @memberof DateFilterComponent
   */
  @Input() placeholder: string = "";

  /**
   *
   * FormControl. If not provided default will be setted
   * @type {FormControl}
   * @memberof DateFilterComponent
   */
  @Input() dateFormControl: FormControl;
  @Input() date_subject: BehaviorSubject<any>;

  /**
   * Min date to be selectable into the date filter.
   *
   * @type {Date}
   * @memberof DateFilterComponent
   */
  @Input() min_date: Date;

  /**
   * Max date to be selectable into the date filter.
   *
   * @type {Date}
   * @memberof DateFilterComponent
   */
  @Input() max_date: Date;

  constructor(private dateAdapter: DateAdapter<Date>, @Optional() private drupal_lang_service: LoadDrupalLangService) {
    super(FiltersTypeEnum.DateFilter);
    if (this.drupal_lang_service) {
      const lang = LoadDrupalLangService.getRawLang();
      if(lang){
        this.dateAdapter.setLocale(lang);
      }
    }
  }

  ngOnInit() {
    if (this.dateFormControl === undefined) {
      this.dateFormControl = new FormControl(new Date());
    }
    if (this.date_subject === undefined) {
      this.date_subject = new BehaviorSubject({});
    }
    this.subs.push(
      this.date_subject
        .asObservable()
        .subscribe(next => (this.date = next.value ? next.value : undefined))
    );
  }
  onChange(event) {
    this.changeData.emit(event);
    this.date_subject.next(event);
  }
  ngOnDestroy(): void {
    this.subs.forEach(value => value.unsubscribe());
  }

  /**
   * Method for open calendar when clicked in input
   *
   * @memberof DateFilterComponent
   */
  open() {

  }
}
